import React, { useCallback, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import NavbarBg from "@assets/ui-helpers/navbar/navbarbg.png";
import useOnclickOutside from "react-cool-onclickoutside";
import type { INavbar } from "@src/types/AppTypes";

// keep static routes in values because if use routes from variables, then it will fail build.
const navOpts = [
  { label: "Message from fatSu", value: "/message" },
  { label: "FatSU’s Origin", value: "/fatsuOrigin" },
  { label: "Facts, Stats, & Faq", value: "/facts-stats-faq" },
  { label: "Metrics", value: "/metrics" },
  { label: "FATSU SHOP", value: "/shop" },
  { label: "Fatsu In Lights", value: "/fatsu-in-lights" },
];

const Navbar: React.FC<INavbar> = ({
  attributes,
  className,
  componentRef,
  id,
  onClick,
  style,
}) => {
  const [navItems, setNavItems] = useState<{ label: string; value: string }[]>(
    []
  );
  const [moreOptions, setMoreOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [moredropdown, setMoredropdown] = useState<boolean>(false);
  const moreOptionListRef = useOnclickOutside(
    () => {
      setMoredropdown(false);
    },
    { ignoreClass: ["swal2-container", "more-button"] }
  );
  const resizeHandler = useCallback(() => {
    if (window.innerWidth >= 1536) {
      setMoreOptions([]);
      setNavItems(navOpts);
    } else if (window.innerWidth < 1280) {
      setMoreOptions(navOpts.slice(navOpts.length - 4, navOpts.length));
      setNavItems(navOpts.slice(0, navOpts.length - 4));
    } else if (window.innerWidth < 1536) {
      setMoreOptions(navOpts.slice(navOpts.length - 2, navOpts.length));
      setNavItems(navOpts.slice(0, navOpts.length - 2));
    }
  }, []);

  useEffect(() => {
    resizeHandler();
    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, [resizeHandler]);

  return (
    <div
      {...attributes}
      className={className}
      style={{
        ...style,
        backgroundImage: `url(${NavbarBg})`,
      }}
      ref={componentRef}
      id={id}
      onClick={
        onClick
          ? onClick
          : () => {
              return;
            }
      }
    >
      {navItems.map((navItem) => {
        return (
          <NavLink
            className="text-[#1D1159] text-xl relative after:duration-150 ease-in-out transition overflow-hidden"
            key={navItem.label}
            to={`${navItem.value}`}
          >
            {({ isActive }) => {
              const c = isActive
                ? "underline decoration-wavy block leading-normal"
                : "block leading-normal hover:underline hover:decoration-wavy";
              return <span className={c}>{navItem.label}</span>;
            }}
          </NavLink>
        );
      })}
      <div className="relative hidden max-2xl:block">
        <button
          onClick={() => setMoredropdown(!moredropdown)}
          className="text-[#1D1159] text-xl ease-in duration-150 hover:scale-95 more-button"
          aria-label="More"
        >
          More <i className="ri-arrow-down-s-fill"></i>
        </button>
        {moredropdown && (
          <ul className="absolute top-9 right-0 bg-primary rounded-2xl p-4 max-xl:w-56 w-44 flex flex-col gap-2 z-10">
            {moreOptions.map((navItem) => {
              return (
                <li key={navItem.label}>
                  <NavLink
                    className="text-[#1D1159] text-xl ease-in duration-150 hover:scale-95"
                    onClick={() => {
                      setMoredropdown(false);
                    }}
                    to={`${navItem.value}`}
                    ref={moreOptionListRef}
                  >
                    {({ isActive }) => {
                      const c = isActive
                        ? "underline decoration-wavy block leading-normal"
                        : "block leading-normal hover:underline hover:decoration-wavy";
                      return <span className={c}>{navItem.label}</span>;
                    }}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Navbar;
